import { useEffect, useState } from 'react'
import { ReactComponent as IconNextArrow } from '@/assets/svgs/next-arrow.svg'
import { ReactComponent as IconPreviousArrow } from '@/assets/svgs/previous-arrow.svg'

const Pagination = ({ total = 5, maxShow = 5, currentPage=1, callback }) => {
    const [current, setCurrent] = useState(currentPage)
    const [shows, setShows] = useState([])

	useEffect(() => {
        onShowCurrent()
        callback(current)
    }, [current])

	useEffect(() => {
        onShowCurrent()
        callback(current > total ? 1 : current)
    }, [total])

    const onSelectPage = i => {
        setCurrent(i > 0 ? i : 1)
    }



    const onShowCurrent = () => {
        let first = 1
        if (current <= Math.floor(maxShow/2)) {
            first = 1
        } else if (current + Math.floor(maxShow/2) > total) {
            first = total - maxShow + 1
        } else {
            first = current - Math.floor(maxShow/2)
        }
        const currentShows = Array.from(Array(maxShow).keys()).map(e => e + first)
        setShows(currentShows)
    }

    return (
        <div className="pagination__list">
            {shows[0] > 1 && (<div className={`pagination__item pagination__icon`}
                key="pre" onClick={() => onSelectPage(shows[0] - maxShow + Math.floor(maxShow/2))}>
                <IconPreviousArrow />
            </div>)}
            {shows.map(i => {
                return (
                    <div className={`pagination__item ${i === current ? 'pagination__item--active' : ''}`}
                        key={i} onClick={() => onSelectPage(i)}>
                        {i}
                    </div>
                )
            })}
            {shows[shows.length - 1] < total && (<div className={`pagination__item pagination__icon`}
                key="post" onClick={() => onSelectPage(shows[0] + maxShow + Math.floor(maxShow/2))}>
               <IconNextArrow />

            </div>)}
        </div>
    )
}

export default Pagination
